import { useState } from "react";
import ButtonControl from "../../../../../components/controls/ButtonControl";
import FileUploaderControl from "../../../../../components/controls/FileUploaderControl";
import { InputField } from "../../../../../components/controls/InputField";
import CertificationTable from "../CertificationTable/CertificationTable";
import "../details.scss";
import { InputPicker, TagPicker } from "rsuite";
import SystemTypes from "../../../../../SystemTypes";
import _ from "lodash";
import {
  CheckboxControl,
  DatePickerControl,
  SelectListControl,
} from "../../../../../components/controls";
import { useEffect } from "react";
import Loading from "../../../../../components/Loading";
import MetricsComponent from "./MetricsComponent";
import {
  FormatUTCDateTimeM,
  FormatUTCOnSave,
} from "../../../../../utilities/DateFormater";
import {
  getFieldName,
  getPosition,
  getValue,
} from "../../../../../utilities/ObservationConfigUtils";
import UserPositionRubricMap from "./UserPositionRubricMap";
import ObservationSettings from "./ObservationSettings";

export const SaveObservationQuestions = (names, observationConfigs) => {
  if (observationConfigs) {
    names?.forEach((name) => {
      const value = getValue(
        observationConfigs,
        name,
        "Certification*QuestionIds"
      );
      observationConfigs[getFieldName(name, "Certification*QuestionIdsData")] =
        value ? value.toString() : null;
    });
  }
  return observationConfigs;
};

export const HandleUTCTimeFormatting = (date) => {
  return date !== null ? FormatUTCOnSave(date) : null;
};

export const HandleObservationDateFormatting = (completeConfig) => {
  if (completeConfig?.AdminSurveyStartDate)
    completeConfig.AdminSurveyStartDate = FormatUTCDateTimeM(
      completeConfig.AdminSurveyStartDate
    );
  if (completeConfig?.AdminSurveyEndDate)
    completeConfig.AdminSurveyEndDate = FormatUTCDateTimeM(
      completeConfig.AdminSurveyEndDate
    );
  if (completeConfig?.TeacherSurveyStartDate)
    completeConfig.TeacherSurveyStartDate = FormatUTCDateTimeM(
      completeConfig.TeacherSurveyStartDate
    );
  if (completeConfig?.TeacherSurveyEndDate)
    completeConfig.TeacherSurveyEndDate = FormatUTCDateTimeM(
      completeConfig.TeacherSurveyEndDate
    );

  return completeConfig;
};

export const TableComponent = ({
  updateObservationConfigs,
  observationConfig,
  addFilter,
  defaultFilter,
  ids,
  name,
  certificationQuestions,
}) => {
  return (
    <CertificationTable
      name={name}
      handleIds={(ids) => {
        if (ids) {
          if (ids.length > 0) {
            updateObservationConfigs(
              ids,
              getFieldName(name, "Certification*QuestionIds")
            );
          } else {
            updateObservationConfigs(
              null,
              getFieldName(name, "Certification*QuestionIds")
            );
          }
        }
      }}
      ids={ids}
      addFilter={addFilter}
      certificationQuestions={certificationQuestions}
      defaultFilter={defaultFilter}
    />
  );
};

const DisplaySettings = ({
  observationConfig,
  updateUserPositionAlternativeMap,
}) => {
  return (
    <div className="observation-component">
      <div className="config-wrapper display-config-wrapper">
        {_.map(getPosition(1, 100), (userPosition, index) => {
          return (
            <div className="user-position-row" key={index}>
              <InputField
                subTitle={userPosition.label}
                value={
                  _.find(
                    observationConfig?.UserPositionAlternativeMap,
                    (x) => x.UserPosition === userPosition.value
                  )?.Name
                }
                fieldName={userPosition.value}
                onChange={(value, fieldName) =>
                  updateUserPositionAlternativeMap(value, fieldName)
                }
              ></InputField>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export const ObservationSection = ({
  observationConfig,
  updateObservationConfigs,
  forceValidate,
  activeObservationConfigTab,
  disabled,
  showCertPositions,
  updateUserPositionRubricMap,
  formattedTeacherObservationRubrics,
  formattedTeacherCertificationRubrics,
  formattedAdminObservationRubrics,
  updateUserPositionSurveyTemplateMap,
  updateUserPositionAlternativeMap,
  adminSurveyList,
  teacherSurveyList,
  orgTreeUsers,
  certificationQuestions,
  school,
}) => {
  const [defaultUserPositionTypes, setDefaultUserPositionTypes] =
    useState(null);
  useEffect(() => {
    if (observationConfig && !observationConfig?.wasEdited) {
      const updatedDefaultUserPositionTypes = {};
      for (const [key, value] of Object.entries(SystemTypes.UserPositionType)) {
        const userPositionAlternative = _.find(
          observationConfig.UserPositionAlternativeMap,
          (x) => x.UserPosition === value
        );
        if (userPositionAlternative && userPositionAlternative.Name) {
          updatedDefaultUserPositionTypes[userPositionAlternative.Name] = value;
        } else {
          updatedDefaultUserPositionTypes[key] = value;
        }
      }
      setDefaultUserPositionTypes(updatedDefaultUserPositionTypes);
    }
  }, [observationConfig]);
  return (
    <>
      {/* <span className={"observation-component-text"} style={{ display: disabled ? "block" : "none" }}>{disabledText}</span> */}
      <div
        className={`observation-component-wrapper ${disabled ? "disabled" : ""}`}
      >
        {activeObservationConfigTab === "Display" && (
          <div className="observation-config-wrapper">
            <h3>User Positions Alternative Display</h3>
            <DisplaySettings
              observationConfig={observationConfig}
              updateUserPositionAlternativeMap={
                updateUserPositionAlternativeMap
              }
            />
          </div>
        )}
        {(activeObservationConfigTab === "Admin" ||
          activeObservationConfigTab === "Teacher") && (
          <div className="observation-config-wrapper">
            <h3> Observation Settings</h3>
            {activeObservationConfigTab === "Admin" && (
              <UserPositionRubricMap
                observationConfig={observationConfig}
                name="Admin"
                updateUserPositionRubricMap={updateUserPositionRubricMap}
                updateUserPositionSurveyTemplateMap={
                  updateUserPositionSurveyTemplateMap
                }
                adminSurveyList={adminSurveyList}
                teacherSurveyList={teacherSurveyList}
                formattedTeacherObservationRubrics={
                  formattedTeacherObservationRubrics
                }
                formattedAdminObservationRubrics={
                  formattedAdminObservationRubrics
                }
                updateObservationConfigs={updateObservationConfigs}
                defaultUserPositionTypes={defaultUserPositionTypes}
              />
            )}
            {activeObservationConfigTab === "Teacher" && (
              <UserPositionRubricMap
                observationConfig={observationConfig}
                updateObservationConfigs={updateObservationConfigs}
                name="Teacher"
                updateUserPositionRubricMap={updateUserPositionRubricMap}
                updateUserPositionSurveyTemplateMap={
                  updateUserPositionSurveyTemplateMap
                }
                adminSurveyList={adminSurveyList}
                teacherSurveyList={teacherSurveyList}
                formattedTeacherObservationRubrics={
                  formattedTeacherObservationRubrics
                }
                formattedAdminObservationRubrics={
                  formattedAdminObservationRubrics
                }
                defaultUserPositionTypes={defaultUserPositionTypes}
              />
            )}
          </div>
        )}
        {(activeObservationConfigTab === "Admin" ||
          activeObservationConfigTab === "Teacher") && (
          <div className="observation-config-wrapper">
            <h3> Certification Settings</h3>
            {activeObservationConfigTab === "Admin" && (
              <ObservationSettings
                name="Admin"
                observationConfig={observationConfig}
                updateObservationConfigs={updateObservationConfigs}
                forceValidate={forceValidate}
                getValue={getValue}
                getFieldName={getFieldName}
                showCertPositions={showCertPositions}
                defaultUserPositionTypes={defaultUserPositionTypes}
                orgTreeUsers={orgTreeUsers}
              />
            )}
            {activeObservationConfigTab === "Teacher" && (
              <ObservationSettings
                name="Teacher"
                observationConfig={observationConfig}
                updateObservationConfigs={updateObservationConfigs}
                forceValidate={forceValidate}
                getValue={getValue}
                getFieldName={getFieldName}
                showCertPositions={showCertPositions}
                formattedTeacherCertificationRubrics={
                  formattedTeacherCertificationRubrics
                }
                defaultUserPositionTypes={defaultUserPositionTypes}
                orgTreeUsers={orgTreeUsers}
              />
            )}
          </div>
        )}
        {activeObservationConfigTab === "Admin" && (
          <TableComponent
            name="Admin"
            observationConfig={observationConfig}
            updateObservationConfigs={updateObservationConfigs}
            getFieldName={getFieldName}
            ids={observationConfig?.CertificationAdminQuestionIds}
            certificationQuestions={certificationQuestions}
            defaultFilter={(items) => {
              return items?.filter(
                (x) =>
                  x?.IsActive === true &&
                  x?.IsDefault === true &&
                  x?.CertificationType == 1
              );
            }} // return active and default questions
          />
        )}
        {activeObservationConfigTab === "Teacher" && (
          <TableComponent
            name="Teacher"
            observationConfig={observationConfig}
            updateObservationConfigs={updateObservationConfigs}
            getFieldName={getFieldName}
            ids={observationConfig?.CertificationTeacherQuestionIds}
            certificationQuestions={certificationQuestions}
            defaultFilter={(items) => {
              return _.filter(
                items,
                (x) =>
                  x?.IsActive === true &&
                  x?.IsDefault === true &&
                  x?.CertificationType == 2
              );
            }}
          />
        )}
        {activeObservationConfigTab === "Metrics" && (
          <MetricsComponent
            observationConfig={observationConfig}
            school={school}
          />
        )}
      </div>
    </>
  );
};

ObservationSection.defaultProps = {
  disabled: false,
  disabledText:
    "Please fill out the above configurations before modifying certification settings.",
};
